import React, { useState } from 'react';
import Header from '../../components/navigation/Header';
import GlobalFilterBar from '../../components/navigation/GlobalFilterBar';
import ComplianceAlertBanner from '../../components/navigation/ComplianceAlertBanner';
import Icon from '../../components/AppIcon';

import Select from '../../components/ui/Select';
import Input from '../../components/ui/Input';
import LearningDashboard from './components/LearningDashboard';
import CourseCard from './components/CourseCard';
import SimulationEnvironment from './components/SimulationEnvironment';
import AssessmentCenter from './components/AssessmentCenter';
import { GraduationCap, BookOpen, Monitor, Award, Search } from 'lucide-react';

const GovernmentTrainingAcademy = () => {
  const [activeTab, setActiveTab] = useState('courses');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedRole, setSelectedRole] = useState('all');
  const [selectedDepartment, setSelectedDepartment] = useState('all');

  const handleFilterChange = (filters) => {







    // Filter changes handled by GlobalFilterBar component
  };const roles = [{ value: 'all', label: 'All Roles' }, { value: 'executive', label: 'Executive Leadership' }, { value: 'hr-manager', label: 'HR Managers' }, { value: 'department-head', label: 'Department Heads' }, { value: 'admin-staff', label: 'Administrative Staff' },
  { value: 'payroll-officer', label: 'Payroll Officers' },
  { value: 'compliance-officer', label: 'Compliance Officers' }];


  const departments = [
  { value: 'all', label: 'All Departments' },
  { value: 'national', label: 'National Government' },
  { value: 'provincial', label: 'Provincial Government' },
  { value: 'local', label: 'Local Government' },
  { value: 'statutory', label: 'Statutory Bodies' },
  { value: 'soe', label: 'State-Owned Enterprises' }];


  const courses = [
  {
    id: 1,
    title: 'Executive Leadership: Board Dashboard Mastery',
    role: 'executive',
    department: 'national',
    duration: '45 min',
    modules: 8,
    difficulty: 'beginner',
    description: 'Master the executive board dashboard with strategic analytics, compliance scoring, and financial projections in PNG Kina format.',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1393416d1-1767055068241.png",
    alt: 'Papua New Guinean executive leader learning strategic dashboard analytics',
    completed: false,
    progress: 0,
    certification: true
  },
  {
    id: 2,
    title: 'HR Managers: Compliance Setup & Monitoring',
    role: 'hr-manager',
    department: 'all',
    duration: '60 min',
    modules: 12,
    difficulty: 'intermediate',
    description: 'Comprehensive training on PNG Employment Act 1978 compliance setup, violation tracking, and automated alert configuration.',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_12abf38c2-1768531199030.png",
    alt: 'Melanesian HR manager studying PNG Employment Act compliance requirements',
    completed: true,
    progress: 100,
    certification: true
  },
  {
    id: 3,
    title: 'Payroll Processing: NASFUND & SWT Calculations',
    role: 'payroll-officer',
    department: 'all',
    duration: '75 min',
    modules: 15,
    difficulty: 'advanced',
    description: 'Step-by-step guide to NASFUND contribution calculations, SWT deductions, and automated government filing procedures.',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_109871ec1-1770857695794.png",
    alt: 'Pacific Islander payroll officer learning NASFUND and SWT calculation procedures',
    completed: false,
    progress: 35,
    certification: true
  },
  {
    id: 4,
    title: 'Department Heads: Team Management & Budget Oversight',
    role: 'department-head',
    department: 'all',
    duration: '50 min',
    modules: 10,
    difficulty: 'intermediate',
    description: 'Learn workforce management, departmental budget tracking in PNG Kina, and compliance impact analysis for your team.',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1cfcd5f2f-1768445733273.png",
    alt: 'Papua New Guinean department head training on team management and budget oversight',
    completed: false,
    progress: 0,
    certification: true
  },
  {
    id: 5,
    title: 'Administrative Staff: Employee Data Entry Essentials',
    role: 'admin-staff',
    department: 'all',
    duration: '30 min',
    modules: 6,
    difficulty: 'beginner',
    description: 'Master employee record management, data entry best practices, and basic reporting for PNG government departments.',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1bd1a9aa6-1768445733301.png",
    alt: 'Melanesian administrative staff learning employee data entry best practices',
    completed: false,
    progress: 0,
    certification: false
  },
  {
    id: 6,
    title: 'Compliance Officers: DLIR Filing & Audit Preparation',
    role: 'compliance-officer',
    department: 'all',
    duration: '65 min',
    modules: 14,
    difficulty: 'advanced',
    description: 'Advanced training on DLIR submission packs, audit trail management, and government filing automation for PNG compliance.',
    thumbnail: "https://img.rocket.new/generatedImages/rocket_gen_img_1891a8c3e-1768604060126.png",
    alt: 'Pacific Islander compliance officer studying DLIR filing and audit preparation procedures',
    completed: false,
    progress: 20,
    certification: true
  }];


  const filteredCourses = courses?.filter((course) => {
    const matchesSearch = course?.title?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    course?.description?.toLowerCase()?.includes(searchQuery?.toLowerCase());
    const matchesRole = selectedRole === 'all' || course?.role === selectedRole;
    const matchesDepartment = selectedDepartment === 'all' || course?.department === selectedDepartment || course?.department === 'all';
    return matchesSearch && matchesRole && matchesDepartment;
  });

  const tabs = [
  { id: 'courses', label: 'Course Catalog', icon: 'BookOpen' },
  { id: 'simulations', label: 'Interactive Simulations', icon: 'Monitor' },
  { id: 'assessments', label: 'Assessment Center', icon: 'Award' }];


  return (
    <div className="min-h-screen bg-background">
      <Header />
      <GlobalFilterBar onFilterChange={handleFilterChange} />
      <ComplianceAlertBanner />
      <main className="container mx-auto px-4 py-8">
        {/* Page Header */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-3">
            <div className="bg-gradient-to-r from-green-700 via-emerald-600 to-green-700 p-3 rounded-lg">
              <Icon name="GraduationCap" size={32} color="white" />
            </div>
            <div>
              <h1 className="text-3xl font-heading font-bold text-foreground">
                Government Training Academy
              </h1>
              <p className="text-muted-foreground">
                Master PNG HR Analytics platform through structured learning paths and interactive tutorials
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-6">
          {/* Learning Dashboard Sidebar - 4 columns */}
          <div className="col-span-12 lg:col-span-4">
            <LearningDashboard courses={courses} />
          </div>

          {/* Main Content Area - 8 columns */}
          <div className="col-span-12 lg:col-span-8">
            {/* Tab Navigation */}
            <div className="bg-card border border-border rounded-lg mb-6">
              <div className="flex border-b border-border">
                {tabs?.map((tab) =>
                <button
                  key={tab?.id}
                  onClick={() => setActiveTab(tab?.id)}
                  className={`flex-1 flex items-center justify-center gap-2 px-6 py-4 text-sm font-semibold transition-colors ${
                  activeTab === tab?.id ?
                  'text-primary border-b-2 border-primary bg-primary/5' : 'text-muted-foreground hover:text-foreground hover:bg-muted/50'}`
                  }>

                    <Icon name={tab?.icon} size={18} color="currentColor" />
                    {tab?.label}
                  </button>
                )}
              </div>
            </div>

            {/* Course Catalog Tab */}
            {activeTab === 'courses' &&
            <div>
                {/* Search and Filters */}
                <div className="bg-card border border-border rounded-lg p-6 mb-6">
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div className="md:col-span-1">
                      <div className="relative">
                        <Icon
                        name="Search"
                        size={18}
                        color="var(--color-muted-foreground)"
                        className="absolute left-3 top-1/2 -translate-y-1/2" />

                        <Input
                        placeholder="Search courses..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e?.target?.value)}
                        className="pl-10" />

                      </div>
                    </div>
                    <div>
                      <Select
                      value={selectedRole}
                      onChange={(e) => setSelectedRole(e?.target?.value)}
                      options={roles} />

                    </div>
                    <div>
                      <Select
                      value={selectedDepartment}
                      onChange={(e) => setSelectedDepartment(e?.target?.value)}
                      options={departments} />

                    </div>
                  </div>
                </div>

                {/* Course Grid */}
                <div className="grid grid-cols-1 gap-6">
                  {filteredCourses?.length > 0 ?
                filteredCourses?.map((course) =>
                <CourseCard key={course?.id} course={course} />
                ) :

                <div className="bg-card border border-border rounded-lg p-12 text-center">
                      <Icon name="BookOpen" size={48} color="var(--color-muted-foreground)" className="mx-auto mb-4" />
                      <h3 className="text-lg font-semibold text-foreground mb-2">No courses found</h3>
                      <p className="text-muted-foreground">Try adjusting your search or filters</p>
                    </div>
                }
                </div>
              </div>
            }

            {/* Interactive Simulations Tab */}
            {activeTab === 'simulations' &&
            <SimulationEnvironment />
            }

            {/* Assessment Center Tab */}
            {activeTab === 'assessments' &&
            <AssessmentCenter />
            }
          </div>
        </div>
      </main>
    </div>);

};

export default GovernmentTrainingAcademy;